
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deleteUser",
      resolverType: "mutation",
      routePath: "/deleteUser",
      httpMethod: "POST",
    });
  